// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gbEyp{padding-inline:16px;padding-bottom:16px}.CsCMB{flex:1;min-height:0}.OKYhq{padding-inline:16px}.m789k{padding-inline:16px}.m789k.GQwWj{padding-bottom:16px}.m789k.KdJEH{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frameFooter": `gbEyp`,
	"fillSlot": `CsCMB`,
	"framePad": `OKYhq`,
	"items": `m789k`,
	"padBottom": `GQwWj`,
	"fullWidth": `KdJEH`
};
export default ___CSS_LOADER_EXPORT___;
